'use client';

import { useEffect, useState } from 'react';

import { TImagesDataById, IImageListItem } from '@northladder/apis';
import { Text } from '@northladder/i18n';

import { translations } from '../../../translations';

import { DeviceImagesCaptureAndUploadV2 } from '../DeviceImagesCaptureAndUpload';
import { DoneUploadingImagesCTA } from '../DoneUploadingImagesCTA';

interface IDevicesImagesListProps {
  completedImages: IImageListItem[];
  imagesDataIds: string[];
  imagesDataById: TImagesDataById;
  onClickDone: () => void;
  pendingImages: IImageListItem[];
  pendingReuploadImages: IImageListItem[];
  productName?: string;
}

/**
 * -----------------------------------------------------------------------------
 * Creates functionality for selecting, uploading and previewing the uploaded
 * image.
 */
export function DevicesImagesListV2({
  completedImages,
  imagesDataIds,
  imagesDataById,
  onClickDone,
  pendingImages,
  pendingReuploadImages,
  productName,
}: IDevicesImagesListProps) {
  const [hasPendingUpload, setHasPendingUpload] = useState(false);

  useEffect(() => {
    const updatedHasPendingUpload = Object.values(imagesDataById).find(
      (imageData) => imageData.status?.toLowerCase() !== 'completed'
    );
    setHasPendingUpload(!!updatedHasPendingUpload);
  }, [imagesDataById]);

  return (
    <main className="min-h-screen">
      <div className="mx-auto max-w-7xl px-4 pb-16 text-center sm:px-6 lg:px-8">
        <div className="mx-auto flex max-w-4xl flex-col items-center py-8">
          <h1 className="text-body-text text-xl font-normal tracking-tight sm:text-xl">
            <Text text={translations.instructions.title} />
          </h1>
          {productName ? (
            <h2 className="text-primary-800 dark:text-primary-300 text-lg font-normal tracking-tight sm:text-lg">
              <Text text={productName} />
            </h2>
          ) : null}
          <p className="text-primary-900 mt-2 max-w-xl font-light dark:text-white ">
            <Text text={translations.instructions.subTitle} />
          </p>
        </div>

        <DeviceImagesCaptureAndUploadV2
          completedImages={completedImages}
          imagesDataIds={imagesDataIds}
          pendingImages={pendingImages}
          pendingReuploadImages={pendingReuploadImages}
        />

        <div className="flex justify-end">
          <DoneUploadingImagesCTA
            isEnabled={!hasPendingUpload}
            onClickDone={onClickDone}
          />
        </div>
      </div>
    </main>
  );
}
